'use client';

import { Button, ButtonProps } from 'antd';
import { useRef, useState, useEffect, ReactNode } from 'react';
import styles from './index.module.css';
import { CustomTooltip } from '../CustomTooltip';

export type ButtonStyleType =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'critical'
  | 'outline'
  | 'grayTextType'
  | 'blackTextType'
  | 'coloredTextType';
export type ButtonSizeType = 'large' | 'medium' | 'icon' | '' | 'noPadding';

type Props = {
  typeButton: ButtonStyleType;
  sizeButton: ButtonSizeType;
  isIndicator?: boolean;
} & ButtonProps;

const SpinLoading = () => {
  return (
    <img
      src="/assets/svg/SpinnerGap.svg"
      alt="spinner"
      className={styles.spinner}
    />
  );
};

export const CustomButton = (props: Props) => {
  const { sizeButton, typeButton, isIndicator, children } = props;
  const indicatorClass = isIndicator ? styles.indicator : '';

  const textRef = useRef<HTMLSpanElement>(null);
  const [isEllipsis, setIsEllipsis] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const el = textRef.current;
      setIsEllipsis(el.scrollWidth > el.clientWidth);
    }
  }, [children]);

  const buttonEl = (
    <Button
      {...props}
      loading={props.loading ? { icon: <SpinLoading /> } : null}
      className={
        (props.disabled ? styles.disabled : '') +
        ' ' +
        indicatorClass +
        ' ' +
        styles.buttonMain +
        ' ' +
        styles[typeButton] +
        ' ' +
        (styles[sizeButton] || '') +
        ' ' +
        (props.className || '')
      }
    >
      {sizeButton === 'icon' ? (
        children // для иконок не заворачиваем
      ) : (
        <span ref={textRef} className={styles.buttonText}>
          {children}
        </span>
      )}
    </Button>
  );

  // CustomTooltip только если кнопка не иконка и есть обрезка
  if (sizeButton !== 'icon') {
    return (
      <CustomTooltip title={isEllipsis ? children : ''}>
        {buttonEl}
      </CustomTooltip>
    );
  }

  return buttonEl;
};
